import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import RegisterPage from "./pages/Register/RegisterPage";
import LoginPage from "./pages/Login/LoginPage";
import PrivateRoute from "./routes/PrivateRoutes";
import GlobalStyles from "./styles/global/global";
import { ThemeProvider } from "styled-components";
import ReportRoutes from "./routes/ReportRoutes";
import SupplyRoutes from "./routes/SupplyRoutes";
import SettingsRoutes from "./routes/SettingsRoutes";
import HomeRoutes from "./routes/HomeRoutes";
import LoginRoute from "./routes/LoginRoute";
import LoginModal from "./components/LoginModal";
import RegisterModal from "./components/RegisterModal";
import { useCombinedStore } from "./store"; // Ajuste na importação

const App: React.FC = () => {
  const theme = useCombinedStore((state) => state.themeZustand);

  /*
   * O TEMA PRECISA APARECER NO HTML, e não só no ThemeProvider.
   *
   * `styles/global/tokens.ts` troca `--bom`, `--aviso` e `--erro` para os
   * valores do escuro num bloco `[data-tema="dark"]` — as três semânticas que
   * mudam de tom entre os temas, para manter contraste. Só que NADA nesta
   * árvore escrevia esse atributo: uma busca por "data-tema" em `src` só achava
   * o próprio tokens.ts. O bloco nunca casava, e no tema escuro o verde, o
   * âmbar e o vermelho continuavam sendo os do papel.
   *
   * O ThemeProvider resolve o que passa por `props.theme`; ele não alcança
   * variável CSS. Esta é a ponte entre os dois.
   */
  useEffect(() => {
    document.documentElement.setAttribute(
      "data-tema",
      theme?.title === "dark" ? "dark" : "light",
    );
  }, [theme?.title]);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalStyles />
        <Routes>
          <Route element={<LoginRoute />}>
            <Route
              path="/register"
              element={
                <RegisterPage>
                  <RegisterModal
                    setIsLoading={function (loading: boolean): void {
                      throw new Error("Function not implemented.");
                    }}
                  />
                </RegisterPage>
              }
            />
            <Route
              path="/login"
              element={
                <LoginPage>
                  <LoginModal />
                </LoginPage>
              }
            />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route index path="/" element={<HomeRoutes />} />
            <Route path="settings/*" element={<SettingsRoutes />} />
            <Route path="reports/*" element={<ReportRoutes />} />
            <Route path="supply/*" element={<SupplyRoutes />} />
            <Route path="/*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
